import React from 'react'
import { TextMediumSM } from '../../../../Components/Text/MediumText';
import StatusDebitNote from './StatusDebitNote';
import PaymentTremdebitNote from './PaymentTermDebitNote';


function DebitNoteSettingsIndex() {
  return (
    <div className=' w-full overflow-y-auto'>
        <TextMediumSM content="Debi tNote" />
        <div className='w-full flex flex-wrap justify-center md:justify-start  items-center'>
        <div className=' w-full md:w-1/2 lg:w-1/3'>
            <PaymentTremdebitNote/>
        </div>
        <div className=' w-full md:w-1/2 lg:w-1/3'>
            <StatusDebitNote/>
        </div>
        
        </div>
    </div>
  )
}

export default DebitNoteSettingsIndex;